import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/dille-kamille.svg")